export default "__VITE_ASSET__Bpwf56O1__"